import Paper from '@material-ui/core/Paper';
import React from 'react';
import logo from '../../assets/images/club-logo.svg';
import { IClub } from '../../store/player/clubs/store';
import Button from '../Button';

interface IProps {
  item: IClub;
  onQuit: (club: IClub) => () => void;
}

const MembershipCard = ({ item, onQuit }: IProps): JSX.Element => {
  return (
    <div className="membership-card">
      <Paper elevation={1} className="paper">
        <div className="membership-content">
          <div>
            <div className="left">
              {item.profileImage ? (
                <img src={item.profileImage} alt={`${item.name} logo`} />
              ) : (
                <img src={logo} alt={`${item.name} logo`} />
              )}
            </div>
            <div className="right">
              <span className="title">{item.name}</span>
              <span className="location">{item.course ? item.course.address : ''}</span>
            </div>
          </div>
          <Button onClick={onQuit(item)} color="primary" variant="outlined" className="button">
            QUIT CLUB
          </Button>
        </div>
      </Paper>
    </div>
  );
};
export { MembershipCard };
